import "@/App.css";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import PrivacyPage from './pages/PrivacyPage';
import LegalPage from './pages/LegalPage';
import FooterNew from './components/FooterNew';

// Simple nav for legal pages (reuses same logo/style)
const LegalNav = () => (
  <header className="fixed top-0 left-0 right-0 z-[100] glass">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 flex items-center justify-between h-16 sm:h-20">
      <a href="/" className="flex-shrink-0">
        <img src="https://customer-assets.emergentagent.com/job_a638eaf5-87e7-49db-ab47-92900872b6eb/artifacts/84ltpppp_CultureCracker_Registered.png" alt="Culture Cracker®" className="h-9 sm:h-12 w-auto" />
      </a>
      <a href="/" className="btn-ghost text-sm py-2 px-4">Zurück</a>
    </div>
  </header>
);

const LegalLayout = ({ children }) => (
  <>
    <LegalNav />
    {children}
    <FooterNew />
  </>
);

function App() {
  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <div className="App bg-[var(--bg-primary)] min-h-screen w-full max-w-full overflow-x-hidden">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/product" element={<ProductPage />} />
            <Route path="/privacy" element={<LegalLayout><PrivacyPage /></LegalLayout>} />
            <Route path="/legal" element={<LegalLayout><LegalPage /></LegalLayout>} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
